<template>
  <div>
    <div class="row">
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-table
            :items="companyWarehouseList"
            :fields="companyWarehouseListHeaders"
            hover
            responsive
            sort-icon-left
            :busy="companyWarehouseListLoading"
            head-row-variant="info"
            table-variant="white"
            show-empty
        >
          <template #empty="scope">
            <h6 class="text-center my-5">
              {{ scope.loading ? "Lütfen Bekleyin" : "Veri Bulunamadı"}}
            </h6>
          </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
                  label="Lütfen Bekleyin..."
              ></b-spinner>
            </div>
          </template>
          <template #cell(isActive)="data">
            <v-chip small label :color="data.item.isActive ? 'success ligthen-2' : 'secondary ligthen-2'">
              {{ data.item.isActive ? 'Aktif' : 'Pasif' }}
            </v-chip>
          </template>
          <template #cell(process)="data">
            <div class="text-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="amber darken-2"
                      @click="openWarehouseDialog(data.item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Düzenle</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="danger darken-2" @click="companyWarehouseDelete({
                    params:{},
                    body:{},
                    urlSegments: [data.item.id]
                  })">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Sil</span>
              </v-tooltip>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <EditWarehouseDialog
        :warehouseProp="warehouseProp"
        :processType="'edit'"
        :showDialog="editWarehouseDialog"
        @dialogChange="(data) => (editWarehouseDialog = data)">
    </EditWarehouseDialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import EditWarehouseDialog from "@/components/management/warehouse-management/dialogs/EditWarehouseDialog.vue";

export default {
  components: {EditWarehouseDialog},
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    }
  },

  data () {
    return {
      editWarehouseDialog: false,
      warehouseProp: null,
    }
  },
  name: "ResultsTableView.vue",
  methods: {
    ...mapActions("company", ["companyWarehouseDelete"]),
    openWarehouseDialog(data) {
      this.warehouseProp = data;
      this.editWarehouseDialog = true;
    }
  },
  computed: {
    ...mapState('company', ['companyWarehouseList','companyWarehouseListLoading','companyWarehouseListHeaders'])
  },
  watch: {
    "editWarehouseDialog": function(newVal) {
      if (!newVal) {
        this.warehouseProp = null;
      }
    }
  }
}
</script>

<style scoped>

</style>